
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 180 90"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0038a8","d":"M0 0h180v90H0z"}}),_c('path',{attrs:{"fill":"#ce1126","d":"M0 45h180v45H0z"}}),_c('path',{attrs:{"d":"M77.942 45L0 90V0","fill":"#fff"}}),_c('g',{attrs:{"transform":"translate(28 45)","fill":"#fcd116"}},[_c('circle',{attrs:{"r":"9"}}),_c('g',{attrs:{"id":"d"}},[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"d":"M-1 0l.062.062L0 0l-.938-.062z","transform":"scale(19)"}}),_c('path',{attrs:{"id":"a","d":"M-.884.116l.05.05L0 0z","transform":"scale(19.2381)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(1 -1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(45)"}})]),_c('use',{attrs:{"xlink:href":"#c","transform":"rotate(90)"}})]),_c('use',{attrs:{"xlink:href":"#d","transform":"rotate(180)"}}),_c('g',{attrs:{"transform":"translate(-2.02)"}},[_c('g',{attrs:{"id":"f","transform":"translate(37.962)"}},[_c('path',{attrs:{"id":"e","d":"M5 0L1.618 1.176l-.073 3.58-2.163-2.854-3.427 1.037L-2 0z"}}),_c('use',{attrs:{"xlink:href":"#e","transform":"scale(1 -1)"}})]),_c('use',{attrs:{"xlink:href":"#f","transform":"rotate(120)"}}),_c('use',{attrs:{"xlink:href":"#f","transform":"rotate(-120)"}})])])])
          )
        }
      }
    